import PropTypes from 'prop-types';
import { useState } from 'react';

import { Spinner, Dropdown, Menu, Dialog, Button, Alert } from '@ctct/ui-react';

import MyAccountApiLite from '../../../../api/MyAccountApiLite';
import userRoles from '../../../../constants/userRoles';
import doGetUsers from '../../utils';

const RemoveAUserFirstDialog = ({ t, onClose, doRefresh }) => {
  const [users, setUsers] = useState(null);
  const [userToRemove, setUserToRemove] = useState('');
  const [menuButtonText, setMenuButtonText] = useState(t('add_user.select_a_user'));

  if (!users) {
    const getUsers = async () => {
      try {
        const localUsers = await doGetUsers();

        setUsers(localUsers);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('exception getting users', e);
      }
    };

    getUsers();
  }

  return (
    <Dialog
      data-qe-id="add-user-full-dialog"
      heading={t('add_user.heading')}
      isOpen
      onDismiss={onClose}
      footerActions={
        <>
          <Button
            text={t('add_user.cancel')}
            kind="secondary"
            onClick={onClose}
            data-qe-id="add-user-cancel-max-users-btn"
          />
          <Button
            text={t('add_user.revoke_access_and_continue')}
            kind="primary"
            onClick={() => {
              const doDeactivate = async (userUuid) => {
                await MyAccountApiLite.deactivateUser(userUuid);
                doRefresh();
              };

              doDeactivate(userToRemove);
            }}
            disabled={!userToRemove}
            data-qe-id="add-user-revoke-access-btn"
          />
        </>
      }
    >
      <Alert kind="warning" message={t('add_user.reached_maximum_users')} />
      {t('add_user.revoke_access_from_a_user')}
      {users ? (
        <Dropdown wrapClassName="user-remove-dropdown">
          <Button text={menuButtonText} block dropdown onClick={() => {}} data-qe-id="remove_user_menu_button" />
          <Menu
            name="actionsExample"
            value={userToRemove}
            items={
              users &&
              users
                // filter out deactivated users and account owner
                .filter((user) => {
                  const { userRoles: localUserRoles, status } = user;
                  const [{ roleId }] = localUserRoles;

                  return status === 'ENABLED' && roleId !== userRoles.SITE_OWNER;
                })
                .map((user) => {
                  const { userDetails, userUuid } = user;
                  const { email, firstName, lastName } = userDetails || {};

                  return {
                    text: `${email} - ${firstName} ${lastName}`,
                    value: userUuid,
                  };
                })
            }
            onChoose={(ev, item) => {
              setUserToRemove(item.value);
              setMenuButtonText(item.text);
            }}
          />
        </Dropdown>
      ) : (
        <>
          <br />
          <Spinner />
        </>
      )}
    </Dialog>
  );
};

RemoveAUserFirstDialog.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  doRefresh: PropTypes.func.isRequired,
};

RemoveAUserFirstDialog.defaultProps = {};

export default RemoveAUserFirstDialog;
